<app-menu [hasChanges]="loadMenu" [title]="canUpdate ? 'Gestión de productos' : 'Busqueda de productos'"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="p-1">
    <div class="p-inputgroup w-full">
        <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
        <div class="w-full">
            <p-autoComplete #autocomplete [(ngModel)]="txtSearch" [suggestions]="resultsSKU"
                (completeMethod)="searchSKU($event)" field="descripcionCorta" (onSelect)="processSKU($event)"
                [completeOnFocus]="true" (onBlur)="validateSelected($event)"
                placeholder="Relacione el código del producto" [minLength]="2" size="small"
                emptyMessage="No existen datos relacionados" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}">
            </p-autoComplete>
        </div>
    </div>
    <span [innerHtml]="message"></span>
    <div class="text-left" *ngIf="(sku?.descripcionCorta??'').trim() != ''">
        <h4 *ngIf="(sku?.codBarras ??'')!=''">Producto: {{sku.codBarras}} - {{sku.descripcionLarga}} </h4>
    </div>
    <p-tabs value="0" (onChange)="tabChange($event)" scrollable>
        <p-tablist>
            <p-tab value="0">Información del producto</p-tab>
            <p-tab value="1" *ngIf="canDo">SEO - WEB</p-tab>
            <p-tab value="2" *ngIf="canDo">Imagenes del producto</p-tab>
            <p-tab value="3" *ngIf="canDo">Localizador de inventario</p-tab>
            <p-tab value="4" *ngIf="canDo">Lista de precios</p-tab>
            <p-tab value="5" *ngIf="canDo">Inventario Cruzado</p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="0">
                <div class="flex flex-wrap" *ngIf="canDo">
                    <div class="w-full md:w-3 pt-1">
                        <label>Categoria <span class="text-xs text-red-700">*</span></label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <p-select [options]="categorias" [(ngModel)]="selectedCategory" class="w-full"
                                optionLabel="descripcion" placeholder="Seleccione la categoria" size="small"
                                (onChange)="getCategoriaNivelN(2,selectedCategory?.idCategorizacionProveedor)"
                                [disabled]="!canUpdate">
                            </p-select>
                        </div>
                    </div>
                    <div class="w-full md:w-3 pt-1">
                        <label>Categoria Nivel 2 <span class="text-xs text-red-700">*</span></label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <p-select [options]="subCategorias" [(ngModel)]="selectedSubCategory" class="w-full"
                                optionLabel="descripcion" placeholder="Seleccione la subcategoria" size="small"
                                (onChange)="getCategoriaNivelN(3,selectedSubCategory?.idCategorizacionProveedor)"
                                [disabled]="!canUpdate">
                            </p-select>
                        </div>
                    </div>
                    <div class="w-full md:w-3 pt-1" *ngIf="subCategoriasN3.length > 0">
                        <label>Categoria Nivel 3</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <p-select [options]="subCategoriasN3" [(ngModel)]="selectedSubCategoryN3" class="w-full"
                                optionLabel="descripcion" placeholder="Seleccione la subcategoria" size="small"
                                (onChange)="getCategoriaNivelN(4,selectedSubCategoryN3?.idCategorizacionProveedor)"
                                [disabled]="!canUpdate" [showClear]="true">
                            </p-select>
                        </div>
                    </div>
                    <div class="w-full md:w-3 pt-1" *ngIf="subCategoriasN4.length > 0">
                        <label>Categoria Nivel 4</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <p-select [options]="subCategoriasN4" [(ngModel)]="selectedSubCategoryN4" class="w-full"
                                optionLabel="descripcion" placeholder="Seleccione la subcategoria"
                                [disabled]="!canUpdate" size="small" [showClear]="true">
                            </p-select>
                        </div>
                    </div>
                    <div class="w-full text-center" *ngIf="canUpdate"><button pButton (click)="divCategorizacion=true"
                            class="p-button p-button-link p-button-success text-xs text-green-700"
                            label="Modificar o crear nuevas categorias"></button></div>
                </div>
                <div class="flex flex-rows" *ngIf="selectedSubCategory?.idCategorizacionProveedor > 0">
                    <h5 class="uppercase p-2 {{infProdBasic ? 'underline bg-primary-700 text-white':''}} cursor-pointer"
                        (click)="infProdBasic=true;">
                        Información Básica</h5>
                    <h5 class="uppercase p-2 {{!infProdBasic ? 'underline bg-primary-700 text-white':''}} cursor-pointer"
                        (click)="infProdBasic=false;">Información Avanzada</h5>
                </div>

                <form action="" [formGroup]="formProducto">
                    <div class="flex flex-wrap" *ngIf="selectedSubCategory?.idCategorizacionProveedor > 0">
                        <div class="w-full md:w-4 p-1">
                            <label>SKU Interno<span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Identificador de uso interno del producto (obligatorio).
                                    </div>
                                </div>
                            </label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-info"></i></span>
                                <p-inputNumber class="w-full " mode="decimal" formControlName="identificador" [min]="1"
                                    size="small" [inputStyle]="{'pointer-events': canUpdate ? 'initial':'none'}">
                                </p-inputNumber>
                            </div>
                        </div>
                        <div class="w-full md:w-4 p-1" *ngIf="!infProdBasic">
                            <label>Referencia <span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Referencia del proveedor
                                    </div>
                                </div>
                            </label>
                            <div class="p-inputgroup" infProdBasic>
                                <span class="p-inputgroup-addon"><i class="pi pi-info"></i></span>
                                <input type="text" pInputText placeholder="Digite la referencia del producto"
                                    pSize="small" formControlName="referencia"
                                    class="{{canUpdate ? '':'disabledPoint'}}">
                            </div>
                        </div>
                        <div class="w-full md:w-4 p-1" *ngIf="!infProdBasic">
                            <label>Código de barras <span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Código de barras para facilitar la lectura el momento de la venta.
                                    </div>
                                </div>
                            </label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                                <input type="text" pInputText placeholder="Relacione el código de barras del producto"
                                    size="null" formControlName="codigoBarras"
                                    class="{{canUpdate ? '':'disabledPoint'}}">
                            </div>
                        </div>
                        <div class="w-full md:w-8 p-1" *ngIf="!infProdBasic">
                            <label>Descripción Larga <span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Descripción larga no mayor a 200 carácteres
                                    </div>
                                </div>
                            </label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                                <input type="text" pInputText placeholder="Digite la descripción larga" pSize="small"
                                    formControlName="descripcionLarga" class="{{canUpdate ? '':'disabledPoint'}}">
                            </div>
                        </div>
                        <div class="w-full md:w-4 p-1">
                            <label>Descripción corta <span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Descripción corta no mayor a 70 caracteres
                                    </div>
                                </div>
                            </label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-info"></i></span>
                                <input type="text" pInputText placeholder="Digite la descripción corta" pSize="small"
                                    formControlName="descripcionCorta" class="{{canUpdate ? '':'disabledPoint'}}">
                            </div>
                        </div>

                        <div class="w-full md:w-4 p-1" *ngIf="!infProdBasic">
                            <label>Marca <span class="text-xs text-red-700">*</span></label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-info"></i></span>
                                <input type="text" pInputText placeholder="Digite la marca" formControlName="marca"
                                    pSize="small" class="{{canUpdate ? '':'disabledPoint'}}">
                            </div>
                        </div>
                        <div class="w-full md:w-4 p-1">
                            <label>Unidad de presentación <span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Unidad de venta del producto <br>
                                        Ej: Paquete x 6, Unidad
                                    </div>
                                </div>
                            </label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-box"></i></span>
                                <input type="text" pInputText placeholder="Digite la unidad de presentación"
                                    pSize="small" formControlName="unidadPresentacion"
                                    class="{{canUpdate ? '':'disabledPoint'}}">
                            </div>
                        </div>
                        <div class="w-full md:w-4 p-1">
                            <label>Impuesto <span class="text-xs text-red-700">*</span></label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-percentage"></i></span>
                                <p-inputNumber [max]="30" [minFractionDigits]="2" class="w-full" mode="decimal"
                                    size="small" formControlName="impuesto"
                                    [inputStyle]="{'pointer-events': canUpdate ? 'initial':'none'}">
                                </p-inputNumber>
                            </div>
                        </div>
                        <div class="w-full {{infProdBasic ?'md:w-4':'md:w-6'}} p-1">
                            <label>Precio venta final cliente <span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Precio de venta al publico sin descuento (con impuesto incluido)
                                    </div>
                                </div>
                            </label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-dollar"></i></span>
                                <p-inputNumber class="w-full" formControlName="precioVenta"
                                    size="small" [min]="100" mode="currency" currency="USD" locale="en-US"
                                    [inputStyle]="{'pointer-events': canUpdate ? 'initial':'none'}"></p-inputNumber>
                            </div>
                        </div>
                        <div class="w-full md:w-6 p-1" *ngIf="!infProdBasic">
                            <label>Precio promoción final cliente <span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Precio promoción con descuento (con impuesto incluido)
                                    </div>
                                </div>
                            </label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-dollar"></i></span>
                                <p-inputNumber class="w-full" mode="currency" currency="USD" locale="en-US"
                                    formControlName="precioPromocion" [min]="100" size="small"
                                    [inputStyle]="{'pointer-events': canUpdate ? 'initial':'none'}"></p-inputNumber>
                            </div>
                        </div>
                        <div class="w-4 text-center" *ngIf="!infProdBasic">
                            <label for="statusSKU">Estado <span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Estado del producto (activo o inactivo)
                                    </div>
                                </div>
                            </label>
                            <p-toggleswitch id="statusSKU" formControlName="estado" size="small"
                                class="{{canUpdate ? '':'disabledPoint'}}">
                            </p-toggleswitch>
                        </div>
                        <div class="w-4 text-center" *ngIf="!infProdBasic">
                            <label for="statusEcommerce">E-commerce
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        ¿Es visible en el E-commerce?
                                    </div>
                                </div>
                            </label>
                            <p-toggleswitch id="statusEcommerce" formControlName="publicado" size="small"
                                class="{{canUpdate ? '':'disabledPoint'}}">
                            </p-toggleswitch>
                        </div>
                        <div class="w-4 text-center" *ngIf="!infProdBasic">
                            <label for="statusSKU">Servicio
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        ¿Es un servicio y no un producto?
                                    </div>
                                </div>
                            </label>
                            <p-toggleswitch formControlName="isService" class="{{canUpdate ? '':'disabledPoint'}}"
                                size="small">
                            </p-toggleswitch>
                        </div>
                        <div class="w-full" *ngIf="!infProdBasic">
                            <label>Información adicional del producto</label>
                            <textarea [rows]="3" class="w-full" pInputTextarea formControlName="informacionAdicional"
                                class="{{canUpdate ? '':'disabledPoint'}}"></textarea>
                        </div>
                        <div class="w-full text-center">
                            <button pButton label="Nueva consulta" class="p-button p-button-danger"
                                icon="pi pi-directions-alt" (click)=reload()></button> &nbsp;
                            <button pButton pRipple label="{{sku.idProducto > 0 ?'Actualizar':'Crear'}}"
                                icon="pi pi-plus" class="p-button p-button-success" *ngIf="canUpdate"
                                (click)="createSKU()"></button>
                        </div>
                    </div>
                </form>


            </p-tabpanel >
            <p-tabpanel value="1">
                <h3 class="uppercase">Referencias SEO</h3>
                <form action="" [formGroup]="formSeo">
                    <div class="flex flex-wrap">
                        <div class="w-full md:w-6 p-1">
                            <label>Título SEO <span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Título de como el buscador presentará el producto
                                    </div>
                                </div>
                            </label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-info"></i></span>
                                <input type="text" pInputText placeholder="Titulo SEO" formControlName="title"
                                    pSize="small" class="{{canUpdate ? '':'disabledPoint'}}">
                            </div>
                        </div>
                        <div class="w-full md:w-6 p-1">
                            <label>SLUG <span class="text-xs text-red-700">*</span>
                                <div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Complemento de la URL (enlace) para buscar el producto
                                    </div>
                                </div>
                            </label>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon"><i class="pi pi-info"></i></span>
                                <input type="text" pInputText placeholder="" formControlName="slug" pSize="small"
                                    class="{{canUpdate ? '':'disabledPoint'}}">
                            </div>
                        </div>
                        <div class="w-full">
                            <label>Meta description<div class="tooltip-container">
                                    <span><i class="pi pi-question-circle pl-2"></i></span>
                                    <div class="tooltip">
                                        Complemento de la URL (enlace) para buscar el producto
                                    </div>
                                </div></label>
                            <textarea [rows]="3" class="w-full h-auto" pInputTextarea [maxlength]="300"
                                formControlName="meta" class="{{canUpdate ? '':'disabledPoint'}}"></textarea>
                        </div>
                    </div>
                </form>
                <div class="w-full text-center">
                    <button pButton label="Guardar" icon="pi pi-save" class="p-button p-button-success"
                        (click)="saveSEO()"></button>
                </div>
            </p-tabpanel>
            <!-- <p-tabpanel header="Caracteristicas del producto" *ngIf="canDo">
            <div class="grid">
                <div class="col-12">
                    <p-autoComplete [select]="true" [(ngModel)]="selectedCharacteristic"
                        [suggestions]="filterCharacteristicArray" (completeMethod)="filterCharacteristic($event)"
                        field="nombreCaracteristica" [multiple]="true" class="w-full"
                        placeholder="Seleccione las posibles caracteristicas del producto" *ngIf="canUpdate">
                    </p-autoComplete>
                </div>
            </div>
            <div class="grid">
                <div class="col-6" *ngFor="let row of selectedCharacteristic">
                    <h5>{{this.canUpdate ?'Digite':''}} {{row.nombreCaracteristica}}</h5>
                    <input type="text" placeholder="Digite {{row.nombreCaracteristica}}" pInputText
                        [(ngModel)]="row.valor" class="w-full" [disabled]="!canUpdate" />
                </div>
                <div class="col-12 text-center" *ngIf="canUpdate">
                    <button pButton label="Nueva consulta" class="p-button p-button-danger" icon="pi pi-directions-alt"
                        (click)=reload()></button> &nbsp;
                    <button pButton class="p-button p-button-success" icon="pi pi-check" (click)="setCaharacteristics()"
                        *ngIf="canUpdate" label="Procesar"></button>
                </div>
            </div>

        </p-tabpanel> -->
            <p-tabpanel value="2">
                <div *ngFor="let row of sku.productoImagenes; let $index =index">
                    <div class="flex flex-wrap align-items-center">
                        <div class="w-full md:w-2 text-center">
                            <p-image src="{{row.ubicacion}}" alt="{{row.etiqueta}}" width="150"
                                [preview]="true"></p-image>
                            <p *ngIf="canUpdate"> Imagen {{row.estado ? 'activa':'inactiva'}}
                                <p-toggleswitch [(ngModel)]="row.estado">
                                </p-toggleswitch>
                            </p>
                        </div>
                        <div class="w-full md:w-8 p-2 flex flex-column" *ngIf="canUpdate">
                            <div><label>Nombre del archivo</label>
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon"><i class="pi pi-info"></i></span>
                                    <input type="text" [(ngModel)]="row.nombreArchivo" pInputText
                                        placeholder="Digite el nombre del archivo">
                                </div>
                            </div>
                            <div>
                                <label>Etiqueta</label>
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon"><i class="pi pi-flag"></i></span>
                                    <input type="text" [(ngModel)]="row.etiqueta" pInputText
                                        placeholder="Digite la etiqueta de busqueda">
                                </div>
                            </div>
                        </div>
                        <div class="w-full md:w-2 p-2 flex flex-row" *ngIf="canUpdate">
                            <div>
                                <label>Orden</label>
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon"><i class="pi pi-sort"></i></span>
                                    <p-inputNumber class="w-full" mode="decimal" [(ngModel)]="row.orden" [min]="1"
                                        [max]="sku.productoImagenes.length"></p-inputNumber>
                                </div>
                            </div>
                        </div>
                        <div class="w-full text-center pb-2" *ngIf="canUpdate">
                            <button pButton icon="pi pi-times-circle" label="Eliminar" class="p-button p-button-danger"
                                (click)="confirm($index)"></button>
                            <button pButton icon="pi pi-check-circle" label="Aceptar" class="p-button p-button-success"
                                (click)="updateAttrImg($index)"></button>
                        </div>
                    </div>
                    <div [innerHTML]="row.message"></div>
                    <hr>
                </div>

                <div class="w-full mx-auto">
                    <div class="flex flex-rows mx-auto" *ngIf="canUpdate">
                        <p-fileUpload #fileUpload name="myfile[]" [customUpload]="true"
                            (uploadHandler)="onUpload($event)" [multiple]="multiple" accept="image/*"
                            [maxFileSize]="500000" chooseLabel="Seleccionar imagenes" uploadLabel="Cargar"
                            cancelLabel="Cancelar"></p-fileUpload>
                    </div>
                </div>
            </p-tabpanel>
            <p-tabpanel value="3">
                <span [innerHTML]="messageInv"></span>
                <div class="w-8 md:w-4 mx-auto">
                    <div *ngFor="let item of tiendas;">
                        <div class=" flex flex-row justify-content-between align-items-center">
                            <h4>{{item.nombreTienda}}:</h4> {{item.tiendaProductos[0].cantidadEnMano +
                            item.tiendaProductos[0].cantidadMasiva}}
                        </div>
                        <hr>
                    </div>
                    <div class="flex flex-row justify-content-between align-items-center">
                        <h4 class="uppercase">Total :</h4>{{totalInventario | number}}
                    </div>
                </div>
            </p-tabpanel>
            <p-tabpanel value="4">
                <div *ngFor="let det of arrayListaPrecios">
                    <div class="border-round flex p-2 flex-wrap">
                        <div class=" w-full md:w-8 flex align-items-center justify-content-center flex-column">
                            <h4 class="uppercase">{{det?.nombreListaPrecios}}</h4>
                            <p class="text-xs" *ngIf="det.default"> Lista de precios orientada al público en general</p>
                        </div>
                        <div class="w-full md:w-4 flex flex-column">
                            <label>Precio (incluido IVA)</label>
                            <div class="p-inputgroup">
                                <div class="p-inputgroup-addon"><i class="pi pi-dollar"></i></div>
                                <p-inputNumber [(ngModel)]="det.detalle.precio" mode="currency" currency="USD" locale="en-US"></p-inputNumber>
                            </div>
                            <label>Precio Promoción(incluido IVA)</label>
                            <div class="p-inputgroup">
                                <div class="p-inputgroup-addon"><i class="pi pi-dollar"></i></div>
                                <p-inputNumber [(ngModel)]="det.detalle.precioPromocion" mode="currency" currency="USD" locale="en-US"></p-inputNumber>
                            </div>
                            <span class="text-xs">Fecha de vigencía: {{det.fechaVigencia | date:'yyyy-MM-dd'}}</span>
                            <button pButton class="p-button p-button-success mt-2" label="Actualizar"
                                icon="pi pi-check-circle" (click)="setPrice(det)"></button>
                        </div>
                        <div class="w-full">
                            <span [innerHTML]="det.message"></span>
                        </div>
                    </div>
                    <hr>
                </div>
            </p-tabpanel>
            <p-tabpanel value="5">
                <div class="w-8 md:w-4 mx-auto">
                    <div class="w-full">
                        <p-autoComplete #autocomplete [(ngModel)]="txtSearch2" [suggestions]="resultsSKU2"
                            (completeMethod)="filterInvCruzado($event)" field="descripcionCorta"
                            (onSelect)="addSKUInvCruzado($event)" [completeOnFocus]="true"
                            placeholder="Relacione el código del producto" [minLength]="2"
                            emptyMessage="No existen datos relacionados" [style]="{'width':'100%'}"
                            [inputStyle]="{'width':'100%'}" styleClass="w-full">
                        </p-autoComplete>
                    </div>
                    <div class="w-full">
                        <ul class="list-none pt-3 ">
                            <li class="flex flex-row p-3 border-1 border-round align-items-center"
                                *ngFor="let item of lsInvCruzado">
                                <i class="pi pi-times-circle "></i> &nbsp;
                                <div>{{item.descripcionCorta}}</div>
                                <div class="w-4 md:w-2"><p-inputNumber placeholder="Cantidad"></p-inputNumber></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>
<p-toast key="message"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<!--Selección de categorias-->
<p-dialog header="Modificar categorización" [(visible)]="divCategorizacion" [modal]="true" [dismissableMask]="false"
    [closeOnEscape]="false" [closable]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw', height:'90vh'}">
    <div class="flex flex-wrap">
        <!--Categoria nivel 1-->
        <div class="w-full">
            <div class="flex flex-row justify-content-between pt-1 text-xs"> ¿Desea incluir una nueva categoría?
                <p-toggleswitch [(ngModel)]="showCategory"></p-toggleswitch>
            </div>
            <div class="p-inputgroup" *ngIf="!showCategory">
                <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                <p-select [options]="categorias" [(ngModel)]="selectedCategory" class="w-full" optionLabel="descripcion"
                    placeholder="Seleccione la categoria"
                    (onChange)="getCategoriaNivelN(2,selectedCategory?.idCategorizacionProveedor)">
                </p-select>
            </div>
            <div class="flex flex-row justify-content-between pt-1 text-xs"
                *ngIf="selectedCategory?.idCategorizacionProveedor > 0 && !showCategory">¿Desea modificar la
                categoría
                seleccionada?
                <p-toggleswitch [(ngModel)]="disabledCategory">
                </p-toggleswitch>
            </div>
            <div *ngIf="showCategory" class="m-2">
                <div class="flex">
                    <div class="w-full">
                        <label>Categoria nueva</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <input type="text" pInputText [(ngModel)]="nameCategory"
                                placeholder="Relacione categoria nueva">
                            <span class="p-inputgroup-addon"><button pButton label="Guardar"
                                    class="p-button p-button-success" icon="pi pi-save"
                                    (click)=saveCategory()></button></span>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="disabledCategory && !showCategory" class="m-2">
                <div class="flex flex-wrap">
                    <div class="w-full">
                        <label>Categoria seleccionada</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <input type="text" pInputText [(ngModel)]="selectedCategory.descripcion"
                                placeholder="Nombre de la categoria">
                        </div>
                    </div>
                    <div class="w-full text-center">
                        <p>Estado de la categoria
                            <p-toggleswitch [(ngModel)]="selectedCategory.activo">
                            </p-toggleswitch>
                        </p>
                    </div>
                    <div class="w-full text-center">
                        <button pButton label="Guardar" class="p-button p-button-success w-auto" icon="pi pi-save"
                            (click)=saveCategory()></button>
                    </div>

                </div>
            </div>
        </div>
        <!--Categoria nivel 2-->
        <div class="w-full" *ngIf="selectedCategory?.idCategorizacionProveedor> 0">
            <div class="flex flex-row justify-content-between pt-1 text-xs"> ¿Desea incluir una nueva categoría nivel 2?
                <p-toggleswitch [(ngModel)]="showSubCategory">
                </p-toggleswitch>
            </div>
            <div class="p-inputgroup" *ngIf="!showSubCategory">
                <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                <p-select [options]="subCategorias" [(ngModel)]="selectedSubCategory" class="w-full"
                    optionLabel="descripcion" placeholder="Seleccione la categoría nivel 2"
                    (onChange)="getCategoriaNivelN(3,selectedSubCategory?.idCategorizacionProveedor)">
                </p-select>
            </div>
            <div class="flex flex-row justify-content-between pt-1 text-xs"
                *ngIf="selectedSubCategory?.idCategorizacionProveedor> 0 && !showSubCategory">¿Desea modificar la
                categoría nivel 2
                seleccionada?
                <p-toggleswitch [(ngModel)]="disabledSubCategory">
                </p-toggleswitch>
            </div>
            <div *ngIf="showSubCategory" class="m-2">
                <div class="flex flex-wrap">
                    <div class="w-full">
                        <label>Categoría nivel 2 nueva</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <input type="text" pInputText [(ngModel)]="nameSubCategory"
                                placeholder="Relacione la subcategoria nueva">
                            <span class="p-inputgroup-addon"><button pButton label="Guardar"
                                    class="p-button p-button-success" icon="pi pi-save"
                                    (click)=saveSubCategory(2)></button></span>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="disabledSubCategory && !showSubCategory" class="m-2">
                <div class="flex flex-wrap">
                    <div class="w-full">
                        <label>Categoría nivel 2 seleccionada</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <input type="text" pInputText [(ngModel)]="selectedSubCategory.descripcion"
                                placeholder="Nombre de la subcategoria">
                        </div>
                    </div>
                    <div class="w-full text-center">
                        <p>Estado de la categoria
                            <p-toggleswitch [(ngModel)]="selectedSubCategory.activo">
                            </p-toggleswitch>
                        </p>
                    </div>
                    <div class="w-full text-center">
                        <button pButton label="Guardar" class="p-button p-button-success" icon="pi pi-save"
                            (click)=saveSubCategory(2)></button>
                    </div>

                </div>
            </div>
        </div>
        <!--Categoria nivel 3-->
        <div class="w-full" *ngIf="selectedSubCategory?.idCategorizacionProveedor> 0">
            <div class="flex flex-row justify-content-between pt-1 text-xs"> ¿Desea incluir una nueva categoría nivel 3?
                <p-toggleswitch [(ngModel)]="showSubCategoryN3">
                </p-toggleswitch>
            </div>
            <div class="p-inputgroup" *ngIf="!showSubCategoryN3">
                <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                <p-select [options]="subCategoriasN3" [(ngModel)]="selectedSubCategoryN3" class="w-full"
                    optionLabel="descripcion" placeholder="Seleccione la subcategoria"
                    (onChange)="getCategoriaNivelN(4,selectedSubCategoryN3?.idCategorizacionProveedor)">
                </p-select>
            </div>
            <div class="flex flex-row justify-content-between pt-1 text-xs"
                *ngIf="selectedSubCategoryN3?.idCategorizacionProveedor> 0 && !showSubCategoryN3">¿Desea modificar la
                subcategoría
                seleccionada?
                <p-toggleswitch [(ngModel)]="disabledSubCategoryN3">
                </p-toggleswitch>
            </div>
            <div *ngIf="showSubCategoryN3" class="m-2">
                <div class="flex flex-wrap">
                    <div class="w-full">
                        <label>Categoria nivel 3 nueva</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <input type="text" pInputText [(ngModel)]="nameSubCategoryN3"
                                placeholder="Relacione la categoria nivel 3 nueva">
                            <span class="p-inputgroup-addon"><button pButton label="Guardar"
                                    class="p-button p-button-success" icon="pi pi-save"
                                    (click)=saveSubCategory(3)></button></span>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="disabledSubCategoryN3 && !showSubCategoryN3" class="m-2">
                <div class="flex flex-wrap">
                    <div class="w-full">
                        <label>Categoría nivel 3 seleccionada</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <input type="text" pInputText [(ngModel)]="selectedSubCategoryN3.descripcion"
                                placeholder="Nombre de la categorían nivel 3">
                        </div>
                    </div>
                    <div class="w-full text-center">
                        <p>Estado de la categoria
                            <p-toggleswitch [(ngModel)]="selectedSubCategoryN3.activo">
                            </p-toggleswitch>
                        </p>
                    </div>
                    <div class="w-full text-center">
                        <button pButton label="Guardar" class="p-button p-button-success" icon="pi pi-save"
                            (click)=saveSubCategory(3)></button>
                    </div>
                </div>
            </div>
        </div>
        <!--Categoria nivel 4-->
        <div class="w-full" *ngIf="selectedSubCategoryN3?.idCategorizacionProveedor> 0">
            <div class="flex flex-row justify-content-between pt-1 text-xs"> ¿Desea incluir una nueva categoría nivel 4?
                <p-toggleswitch [(ngModel)]="showSubCategoryN4">
                </p-toggleswitch>
            </div>
            <div class="p-inputgroup" *ngIf="!showSubCategoryN4">
                <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                <p-select [options]="subCategoriasN4" [(ngModel)]="selectedSubCategoryN4" class="w-full"
                    optionLabel="descripcion" placeholder="Seleccione la subcategoria">
                </p-select>
            </div>
            <div class="flex flex-row justify-content-between pt-1 text-xs"
                *ngIf="selectedSubCategoryN4?.idCategorizacionProveedor> 0 && !showSubCategoryN4">¿Desea modificar la
                subcategoría
                seleccionada?
                <p-toggleswitch [(ngModel)]="disabledSubCategoryN4">
                </p-toggleswitch>
            </div>
            <div *ngIf="showSubCategoryN4" class="m-2">
                <div class="flex flex-wrap">
                    <div class="w-full">
                        <label>Categoria nivel 4 nueva</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <input type="text" pInputText [(ngModel)]="nameSubCategoryN4"
                                placeholder="Relacione la categoria nivel 4 nueva">
                            <span class="p-inputgroup-addon"><button pButton label="Guardar"
                                    class="p-button p-button-success" icon="pi pi-save"
                                    (click)=saveSubCategory(4)></button></span>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="disabledSubCategoryN4  && !showSubCategoryN4" class="m-2">
                <div class="flex flex-wrap">
                    <div class="w-full">
                        <label>Categoría nivel 4 seleccionada</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            <input type="text" pInputText [(ngModel)]="selectedSubCategoryN4.descripcion"
                                placeholder="Nombre de la categoría nivel 4">
                        </div>
                    </div>
                    <div class="w-full text-center">
                        <p>Estado de la categoria
                            <p-toggleswitch [(ngModel)]="selectedSubCategoryN4.activo">
                            </p-toggleswitch>
                        </p>
                    </div>
                    <div class="w-full text-center">
                        <button pButton label="Guardar" class="p-button p-button-success" icon="pi pi-save"
                            (click)=saveSubCategory(4)></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>